import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockType } from '../../@types/BlockType';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';

import { block_translation } from '../../lang/BlockTranslation';
import { GlobalImport } from '../../utils/GlobalImport';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class ARFaceMarkerBlock extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.FACE_AR_MARKER, t.to('顔ARマーカー', 'ar_face_marker'));
    this.setNameForCode('mindar-face-marker');
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setElementWithSubBlockShape(block);
    ColorSettings.setARColor(block);
    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.addAttributeInput(block);
    ShapeSettings.addStatementInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    let attribute = CodeSetting.getSubAttributeCode(block);
    attribute += CodeSetting.getAttributeCode('mindar-face-target', `anchorIndex: 1`);
    const sub = CodeSetting.getSubstatementCode(block);

    const str = CodeSetting.getElementCode('a-entity', attribute, block.id, sub);
    return str;
  }
}
